
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import CityForm from '../components/forms/CityForm';
import '../styles/EmployeeMaster.css';
import CityTable from '../components/CityTable';

const CityModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/city/add';

  const handleAddClick = () => {
    navigate('/city/add');
  };

  const handleCloseModal = () => {
    navigate('/city');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>City Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add City
        </button>
      </div>

      <CityTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New City</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CityForm />
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default CityModel;
